const SECTION_SELECTOR = ".section--contrast-pairs";
const LINE_TARGET_SELECTOR = "[data-reveal-lines]";
const DESKTOP_MIN_WIDTH = 1199;
const DEFAULT_TRIGGER_START = "top 85%";
const LINE_STAGGER = 0.12;

class ContrastPairsReveal {
  constructor() {
    this.section = document.querySelector(SECTION_SELECTOR);
    this.splitInstances = [];

    if (!this.section || typeof gsap === "undefined") {
      return;
    }

    if (window.innerWidth < DESKTOP_MIN_WIDTH) {
      return;
    }

    if (typeof SplitText === "undefined") {
      console.warn(
        "SplitText is not available. contrast-pairs line reveal will not run.",
      );
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
    this.init();
  }

  isPastTrigger(element, triggerStart = DEFAULT_TRIGGER_START) {
    const rect = element.getBoundingClientRect();
    const triggerPercent = parseFloat(triggerStart.split(" ")[1]) / 100 || 0.85;

    return rect.top < window.innerHeight * triggerPercent;
  }

  createLineReveal(element) {
    const split = new SplitText(element, {
      type: "lines",
      linesClass: "contrast-pairs__line",
    });

    this.splitInstances.push(split);

    const duration = parseFloat(element.dataset.revealDuration) || 0.75;
    const delay = parseFloat(element.dataset.revealDelay) || 0;

    gsap.set(split.lines, {
      opacity: 0.01,
      y: 50,
      visibility: "visible",
      force3D: true,
      willChange: "transform, opacity",
    });

    const play = () => {
      gsap.to(split.lines, {
        opacity: 1,
        y: 0,
        duration,
        delay,
        ease: "power2.out",
        stagger: LINE_STAGGER,
        force3D: true,
        onComplete: () => {
          element.classList.add("is-revealed");
          split.lines.forEach((line) => {
            line.style.willChange = "auto";
          });
        },
      });
    };

    if (this.isPastTrigger(element)) {
      play();
      return;
    }

    ScrollTrigger.create({
      trigger: element,
      start: DEFAULT_TRIGGER_START,
      once: true,
      onEnter: play,
    });
  }

  init() {
    this.section.querySelectorAll(LINE_TARGET_SELECTOR).forEach((element) => {
      this.createLineReveal(element);
    });
  }
}

if (document.querySelector(SECTION_SELECTOR)) {
  new ContrastPairsReveal();
}

export default ContrastPairsReveal;
